document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('ramadanModal');
    if (!modal) return;

    const startDate = modal.dataset.startDate;
    const closeBtn = modal.querySelector('.close-button');
    const overlay = modal.querySelector('.ramadan-modal__overlay');
    const form = modal.querySelector('#ramadan-form');
    const submitButton = form.querySelector('button');
    const buttonLoader = submitButton.querySelector('.loader');
    const timer = modal.querySelector('.timer h4');

    const closeModal = () => {
        modal.classList.remove('active');
        localStorage.setItem('modalLastShown', new Date().toISOString());
    };

    const showModal = () => {
        modal.classList.add('active');
    };

    // ===== Таймер дней =====
    if (startDate && timer) {
        let start;

        // формат 27/01/2026
        if (startDate.includes('/')) {
            const [day, month, year] = startDate.split('/');
            start = new Date(`${year}-${month}-${day}`);
        } else {
            start = new Date(startDate);
        }

        const now = new Date();
        now.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);

        const diffMs = start - now;
        const diffDays = Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));

        timer.textContent = diffDays;
    }
    // =======================

    const shouldShowModal = () => {
        const lastShown = localStorage.getItem('modalLastShown');
        if (!lastShown) return true;
        const lastDate = new Date(lastShown);
        const now = new Date();
        return lastDate.toDateString() !== now.toDateString();
    };

    if (shouldShowModal()) {
        if (startDate) {
            const now = new Date();
            const start = new Date(startDate);
            if (now <= start) {
                setTimeout(showModal, 800);
            }
        } else {
            showModal();
        }
    }

    const showButtonLoader = () => {
        submitButton.disabled = true;
        if (buttonLoader) buttonLoader.style.display = 'block';
    };

    const hideButtonLoader = () => {
        submitButton.disabled = false;
        if (buttonLoader) buttonLoader.style.display = 'none';
    };

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        showButtonLoader();

        const formData = new FormData(form);
        const jsonData = JSON.stringify(Object.fromEntries(formData.entries()));

        fetch(form.action, {
            method: form.method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: jsonData
        })
            .then(async response => {
                if (!response.ok) throw await response.text();
                return response.json();
            })
            .then(() => {
                hideButtonLoader();
                closeModal();
            })
            .catch(err => {
                console.error('ERR:', err);
                hideButtonLoader();
            });
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
});